export const GET_LATEST_NEWS_PENDING = 'GET_LATEST_NEWS_PENDING';
export const GET_LATEST_NEWS_FULFILLED = 'GET_LATEST_NEWS_FULFILLED';
export const GET_LATEST_NEWS_REJECTED = 'GET_LATEST_NEWS_REJECTED';
export const GET_RDR_PENDING = 'GET_RDR_PENDING';
export const GET_RDR_FULFILLED = 'GET_RDR_FULFILLED';
export const GET_RDR_REJECTED = 'GET_RDR_REJECTED';
export const GET_RETAILER_PENDING = 'GET_RETAILER_PENDING';
export const GET_RETAILER_FULFILLED = 'GET_RETAILER_FULFILLED';
export const GET_RETAILER_REJECTED = 'GET_RETAILER_REJECTED';

export default function latestNewsReducer(state = {
  latestNews: [],
  rdrNews: [],
  retailerNews: [],
  fetching: false,
  fetched: false
}, action) {
  switch (action.type) {
    case GET_RDR_PENDING:
    case GET_RETAILER_PENDING:
    case GET_LATEST_NEWS_PENDING: {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case GET_LATEST_NEWS_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        latestNews: action.payLoad.data
      };
    }
    case GET_RDR_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        rdrNews: action.payLoad.data
      };
    }
    case GET_RETAILER_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        retailerNews: action.payLoad.data
      };
    }
    case GET_RDR_REJECTED:
    case GET_RETAILER_REJECTED:
    case GET_LATEST_NEWS_REJECTED: {
      return {
        ...state,
        errors: action.payLoad.errors
      };
    }
    default:
  }

  return {...state};
}
